export default "__VITE_ASSET__1TcgltH$__"